module.exports = __webpack_public_path__ + "img/picking.5bbb3b75.jpg";